module.exports = __webpack_public_path__ + "img/top9-right.fb1e82de.png";